import React from 'react';
import { Button, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ActionBar, StyledEllipsis, StyledEllipsisTooltip } from './styled';
import {
  dimensionDrilldown,
  initFilter,
  toggleCompareRule,
  toggleRule,
} from '@store/trends/base/actions';
import { modeAtom, TABLE_MODES } from '../atoms';
import { useAtomValue } from 'jotai';
import { CopyOutlined } from '@ant-design/icons';
import copy from 'copy-to-clipboard';
import { ruleSetSelector } from '@store/trends/base/selectors';
import { isEcoSankeyEnabledSelector } from '@store/common/selectors';
import { DrillDownToEventScope } from '@components/common/DrillDownToEventScope';
import { activeDashboardSelector } from '@src/store/tempDashboard/selectors';
import { DrillDownToSankey } from '@components/common/DrillDownToSankey';
import { isAppModule } from '@utils/constants';

const actions = [{ label: <CopyOutlined />, value: 'copy' }];

function Cell({ cellData, column, rowData }) {
  const dispatch = useDispatch();
  const mode = useAtomValue(modeAtom);
  const dimension = column.key;
  const { usecaseKey } = useSelector(activeDashboardSelector);

  const activeRuleSet = useSelector(ruleSetSelector);
  const isEcoSankeyEnabled = useSelector(isEcoSankeyEnabledSelector);

  const handleClick = () => {
    if (!rowData.disableDrilldown) {
      switch (mode) {
        case TABLE_MODES.drilldown: {
          dispatch(dimensionDrilldown(dimension, rowData));
          break;
        }
        case TABLE_MODES.filter: {
          dispatch(toggleRule(dimension, rowData));
          break;
        }
        case TABLE_MODES.compare: {
          if (activeRuleSet.size === 0) {
            dispatch(initFilter({ dimension, row: rowData }));
          } else {
            dispatch(toggleCompareRule(dimension, rowData));
          }
          break;
        }
      }
    }
  };

  const handleActions = (value) => {
    if (value === 'copy') {
      return () => {
        if (copy(cellData)) {
          message.info('Copied to clipboard');
        }
      };
    }
    return () => null;
  };

  const styles = rowData.disableDrilldown ? { pointerEvents: 'none' } : {};

  return (
    <>
      <StyledEllipsis onClick={handleClick} style={styles}>
        <StyledEllipsisTooltip text={cellData} />
      </StyledEllipsis>
      <Actions
        handleActions={handleActions}
        dimension={dimension}
        rowData={rowData}
        isEcoSankeyEnabled={isEcoSankeyEnabled}
        usecaseKey={usecaseKey}
      />
    </>
  );
}

function Actions({ handleActions, dimension, rowData, isEcoSankeyEnabled, usecaseKey }) {
  return (
    <ActionBar className="action-bar">
      {isAppModule && !usecaseKey && (
        <DrillDownToEventScope dimension={dimension} rowData={rowData} />
      )}
      {isAppModule && dimension === 'event_name' && isEcoSankeyEnabled && (
        <DrillDownToSankey dimension={dimension} rowData={rowData} />
      )}

      {actions.map((action) => (
        <Button
          key={action.value}
          type="text"
          icon={action.label}
          style={
            isAppModule
              ? {
                  color: '#0046ff',
                }
              : {}
          }
          onClick={handleActions(action.value)}
        />
      ))}
    </ActionBar>
  );
}

export default Cell;
